"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoogleClient = void 0;
var GoogleClient;
(function (GoogleClient) {
    GoogleClient["GOOGLE_SIGNIN_CLIENT_ID"] = "724999241199-i7fd4b5be4127cqp8lb68vlc0ljrhes7.apps.googleusercontent.com";
})(GoogleClient = exports.GoogleClient || (exports.GoogleClient = {}));
//# sourceMappingURL=googleClient.enum.js.map